export enum ScopeRule {
  SCOPE_HIDE_WITHMESSAGE = "SCOPE_HIDE_WITHMESSAGE",
  SCOPE_HIDE = "SCOPE_HIDE",
  SCOPE_BUTTON_DISABLE = "SCOPE_BUTTON_DISABLE",
  SCOPE_LIMIT = "SCOPE_LIMIT",
}
